import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { displayErrorMessage } from '../utils/errorHandler';
const useDeleteItem = (axiosPrivate, deleteEndpoint, deleteAction) => {
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();

  const deleteItem = async (id) => {
    try {
      await axiosPrivate.delete(`${deleteEndpoint}/${id}`);
      deleteAction(id);
      enqueueSnackbar(t("deleteMessageSuccess"), { variant: "success" });
    } catch (err) {
      if (err?.response?.data?.message === "Cannot delete this entity as it is currently in use.") {
        enqueueSnackbar(t("deleteCannotDeleteIsUsed"), { variant: "warning" });
      } else {
        displayErrorMessage(err, enqueueSnackbar);
      }
    }
  };

  return deleteItem;
};

export default useDeleteItem;
